import { c as _c } from "react/compiler-runtime";
import { DropdownMenu } from '@common/components';
import { cn } from '@core/utils';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { UnauthApi, UnauthQueryKey, UnauthQueryOptions } from '@/api';
import { InfiniteListWithMoreButton } from '@/app/donation/_components/InfiniteListWithMoreButton';
import { PhotoReviewSwiper } from '@/app/donation/_components/PhotoReviewSwiper';
import { ReviewCard } from '@/app/donation/_components/ReviewCard';
import { ReviewDetailSessionPortal } from '@/app/donation/_components/ReviewDetailSessionPortal';
import { InfiniteListMoreButton } from '../InfiniteListMoreButton';
import { SectionTitle } from '../SectionTitle';
interface ReviewsContentProps {
  institutionId: number;
}
type SortValue = 'LATEST' | 'RATING_DESC';
const SORT_OPTIONS: {
  value: SortValue;
  label: string;
}[] = [{
  value: 'LATEST',
  label: '최신등록순'
}, {
  value: 'RATING_DESC',
  label: '평점 높은순'
}];
const PAGE_SIZE = 3;
export const ReviewsContent = t0 => {
  const $ = _c(33);
  const {
    institutionId
  } = t0;
  const [selectedSort, setSelectedSort] = useState("LATEST");
  const [detailReviewId, setDetailReviewId] = useState();
  let t1;
  if ($[0] !== institutionId) {
    t1 = UnauthQueryOptions["get:/wello/v2/allows/home/gift-review/photo"]({
      query: {
        institutionId,
        page: 1,
        size: 10
      }
    });
    $[0] = institutionId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      ...t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: photoReviewRes
  } = useSuspenseQuery(t2);
  let t3;
  if ($[4] !== photoReviewRes?.context?.contents) {
    t3 = photoReviewRes?.context?.contents ?? [];
    $[4] = photoReviewRes?.context?.contents;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const photoReviewList = t3;
  const photoReviewCount = photoReviewRes?.context?.totalCount ?? 0;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SectionTitle className={cn("mb-20", "mobile-tablet:mb-12")}>후기</SectionTitle>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== photoReviewList) {
    t5 = photoReviewList.map(_temp);
    $[7] = photoReviewList;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== institutionId || $[10] !== photoReviewCount || $[11] !== t5) {
    t6 = <PhotoReviewSwiper photoReviewList={t5} photoReviewCount={photoReviewCount} institutionId={institutionId} />;
    $[9] = institutionId;
    $[10] = photoReviewCount;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== selectedSort) {
    t7 = <div className="my-12 flex items-center justify-end px-20"><DropdownMenu type="text" value={selectedSort} options={SORT_OPTIONS} onChange={setSelectedSort} align="end" contentClassName="!min-w-160" /></div>;
    $[13] = selectedSort;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <InfiniteListMoreButton className={cn("mt-40", "mobile-tablet:mx-20 mobile-tablet:mt-14")} />;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t10;
  let t9;
  if ($[16] !== institutionId || $[17] !== selectedSort) {
    t9 = [...UnauthQueryKey["get:/wello/v2/allows/home/gift-review"](), selectedSort, institutionId, PAGE_SIZE];
    t10 = t11 => {
      const {
        pageParam
      } = t11;
      return UnauthApi["get:/wello/v2/allows/home/gift-review"]({
        query: {
          institutionId,
          sortType: selectedSort,
          page: pageParam,
          size: PAGE_SIZE
        }
      }).then(_temp2);
    };
    $[16] = institutionId;
    $[17] = selectedSort;
    $[18] = t10;
    $[19] = t9;
  } else {
    t10 = $[18];
    t9 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = item => <button type="button" onClick={() => setDetailReviewId(item.reviewId)} className="w-full"><ReviewCard rating={item.rating} createdAt={item.createdAt} productName={item.productName} contents={item.contents} reviewer={item.nickname} imageUrlList={item.fileUrlList} answer={item.answer} answerAt={item.answerAt} /></button>;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t9) {
    t12 = <div className="flex flex-col"><InfiniteListWithMoreButton moreButtonComponent={t8} moreButtonClassName="px-20" queryKey={t9} queryFn={t10} pageSize={PAGE_SIZE} renderItem={t11} getItemKey={_temp3} /></div>;
    $[21] = t10;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const t13 = !!detailReviewId;
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setDetailReviewId(undefined);
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== detailReviewId || $[26] !== t13) {
    t15 = <ReviewDetailSessionPortal open={t13} onClose={t14} reviewId={detailReviewId} />;
    $[25] = detailReviewId;
    $[26] = t13;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t12 || $[29] !== t15 || $[30] !== t6 || $[31] !== t7) {
    t16 = <div>{t4}{t6}{t7}{t12}{t15}</div>;
    $[28] = t12;
    $[29] = t15;
    $[30] = t6;
    $[31] = t7;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  return t16;
};
function _temp(t0) {
  const {
    fileUrl: file_url,
    reviewId: review_id
  } = t0;
  return {
    fileUrl: file_url,
    reviewId: review_id
  };
}
function _temp2(data) {
  return data.data?.context?.contents ?? [];
}
function _temp3(item_0) {
  return item_0.reviewId;
}